<script>
/**
 * @file 积分详情
 */
import ForkissIcon from './forkiss-icon';

export default {
    components: {
        ForkissIcon
    },
    methods: {
        goback() {
            this.$router.push({
                name: 'my-center'
            });
        }
    }
};
</script>

<template lang="pug">
.forkiss-points-detail-container
    .points-detail-container
        .points-detail-header
            .back-btn(@click="goback", data-touch="true")
            .points
                ForkissIcon.points-icon(icon="forkiss-icon-points")
        .points-detail-main
            .title
                span 积分说明
            p.content FORKISS孕妈妈俱乐部会员（简称FORKISS会员）从2018年11月1日始即可享受FORKISS为您提供课程及YOGA教具（瑜伽垫、抱枕、分娩球）、常玲专家健康咨询积分兑换等服务。
            .sub-title
                span 积分兑换
            ul.exchange-info-list
                li.exchange-info-item
                    .info-title 800积分可兑换：
                    .info-content 常玲医生健康咨询1次（30分钟）：为孕期、产后、育儿的您提供全方面的健康帮助
                li.exchange-info-item
                    .info-title 680积分可兑换：
                    .info-content FORKISS十周年限量版导师签名款瑜伽垫
                li.exchange-info-item
                    .info-title 650积分可兑换：
                    .info-content FORKISS为孕期的您量身定制的暖心款抱枕
                li.exchange-info-item
                    .info-title 380积分可兑换：
                    .info-content FORKISS十周限量版瑜伽球
            ul.image-list
                li.image-item.image-item-1
                li.image-item.image-item-2
                li.image-item.image-item-3
                li.image-item.image-item-4
            .sub-title
                span 积分获得
            ul.gain-info-list
                li.gain-info-item A. 推荐入会赠送 300分
                li.gain-info-item B. 意见反馈（点评/调研）赠送200分
                li.gain-info-item C. 参与活动赠送100分
                li.gain-info-item D. 新会员积分赠送
            .sub-title
                span 兑换方式
            p 积分兑换仅支持线下进行，欢迎会员至FORKISS门店咨询。

</template>

<style lang="less" scoped>
.forkiss-points-detail-container {
    position: relative;
    font-size: .24rem;
    background: #c59869;
    padding-bottom: 1.16rem;

    p.content {
        margin: .3rem 0;
    }
    .back-btn {
        position: absolute;
        z-index: 22;
        top: .2rem;
        left: .2rem;
        width: .44rem;
        height: .44rem;
        background-image: url(../assets/back.svg);
        background-size: contain;
    }
    .points-detail-header {
        height: 5.37rem;
        background-image: url(../assets/points-header.png);
        background-size: cover;
        background-position: center;

        .points {
            padding: 1.12rem 0 .8rem;
            font-size: .98rem;
            color: #FFF;
            text-align: center;

            .points-icon {
                display: inline-block;
                margin-left: .16rem;
            }
        }
    }
    .points-detail-main {
        margin: -2.1rem .3rem 0;
        padding: .6rem;
        border-radius: .1rem;
        background: rgb(238, 224, 210);
        color: #666;

        .title {
            font-size: .26rem;
            font-weight: 600;
            color: #c59869;
            text-align: center;

            &::before {
                content: "";
                display: inline-block;
                vertical-align: middle;
                width: .24rem;
                height: .24rem;
                background-image: url(../assets/double-slant.svg);
                background-size: contain;
                background-repeat: no-repeat;
                background-position: center;
            }

            &::after {
                content: "";
                display: inline-block;
                vertical-align: middle;
                width: .24rem;
                height: .24rem;
                background-image: url(../assets/double-slant.svg);
                background-size: contain;
                background-repeat: no-repeat;
                background-position: center;
            }

            span {
                display: inline-block;
                vertical-align: middle;
                margin: 0 .2rem;
            }
        }

        .sub-title {
            position: relative;
            display: inline-block;
            margin-top: .48rem;
            margin-bottom: .32rem;
            font-size: .28rem;
            color: #666;
            font-weight: 600;

            span {
                position: relative;
                z-index: 2;
            }
            &::after {
                content: "";
                position: absolute;
                width: 100%;
                height: .12rem;
                left: 0;
                bottom: 0;
                border-radius: .1rem;
                background: #e7bd90;
                z-index: 1;

            }

        }

        ul {
            list-style: none;
            padding: 0;
        }
        .exchange-info-list {
            .exchange-info-item {
                position: relative;

                .info-title {
                    font-weight: 600;
                }
                .info-content {
                    margin: .1rem 0 .3rem;
                }
                &::before {
                    content: "";
                    position: absolute;
                    top: .11rem;
                    left: -.2rem;
                    width: .08rem;
                    height: .08rem;
                    background-image: url(../assets/circle.svg);
                    background-size: contain;
                    background-repeat: no-repeat;
                }
            }
        }


        .image-list {
            .image-item {
                display: inline-block;
                width: 2.44rem;
                height: 2.44rem;
                background-repeat: no-repeat;
                background-position: center;
                background-size: cover;
                border-radius: 50%;
                border: .06rem solid #edd3b7;
            }

            .image-item-1 {
                background-image: url(../assets/points-bg1.png);
                margin-right: .68rem;
                margin-bottom: .4rem;
            }
            .image-item-2 {
                background-image: url(../assets/points-bg2.png);
                margin-bottom: .4rem;
            }
            .image-item-3 {
                background-image: url(../assets/points-bg3.png);
                margin-right: .68rem;
            }
            .image-item-4 {
                background-image: url(../assets/points-bg4.png);
            }
        }
    }

    .gain-info-list {
        line-height: 1.8;
    }

}
</style>



// WEBPACK FOOTER //
// src/components/points-detail.vue